import { Spinner } from '@blueprintjs/core';

import useGetInvoiceableCentsForVendorAndPeriod from '../../graphql/queries/web/maintenance/useGetInvoiceableCentsForVendorAndPeriod';
import { costCentsToDollarsAndCents } from '../../utils/cost';
import { stringDateToProto } from '../../utils/date';
import VerticalLayout from '../layouts/VerticalLayout';

interface TotalInvoiceableCostBadgeProps {
  organizationId: string;
  startPeriodOn: string;
  endPeriodOn: string;
}

const TotalInvoiceableCostBadge = ({
  organizationId,
  startPeriodOn,
  endPeriodOn,
}: TotalInvoiceableCostBadgeProps) => {
  const startPeriodOnDate = stringDateToProto(startPeriodOn);
  const endPeriodOnDate = stringDateToProto(endPeriodOn);

  const { data, loading, error } = useGetInvoiceableCentsForVendorAndPeriod({
    variables: {
      orgId: organizationId,
      startPeriod: startPeriodOnDate,
      endPeriod: endPeriodOnDate,
    },
  });

  if (loading) {
    return <Spinner />;
  }
  // todo: on error show toaster
  if (error || !data || !data.webMaintenance.getInvoiceableCentsForVendorAndPeriod) {
    return null;
  }

  const totalInvoiceableCostCents =
    data.webMaintenance.getInvoiceableCentsForVendorAndPeriod.totalInvoiceableCents;
  const formattedCost = costCentsToDollarsAndCents(totalInvoiceableCostCents);

  return (
    <VerticalLayout style={{ ...styles.container, borderStyle: 'solid' }}>
      <span style={styles.cost}>{formattedCost}</span>
      <span style={styles.subtitle}>Total Invoiceable</span>
    </VerticalLayout>
  );
};

export default TotalInvoiceableCostBadge;

const styles = {
  container: {
    borderWidth: 1,
    borderColor: '#C7CFD7',
    borderRadius: 8,
    maxHeight: '10vh',
    maxWidth: '9vw',
    padding: '1vw',
  },
  cost: {
    color: '#092C4D',
    fontWeight: '500',
    fontSize: 20,
  },
  subtitle: {
    marginTop: '1vh',
    marginBottom: '1vh',
  },
};
